import type {
  ConsumptionSettingsResponse,
  ConsumptionSummaryResponse,
  ConsumptionSyncResponse,
  DashboardConsumptionSettingsResponse,
  DashboardConsumptionSummaryResponse,
  DashboardConsumptionSyncResponse,
} from '@protoss/shared';
import { apiFetch } from '../../../lib/apiClient';

export const consumptionApi = {
  getSettings(projectUuid: string): Promise<ConsumptionSettingsResponse> {
    return apiFetch(`/api/project/${projectUuid}/consumption/settings`);
  },

  getSummary(
    projectUuid: string,
    params?: { fromDate?: string; toDate?: string; includeDailyRows?: boolean }
  ): Promise<ConsumptionSummaryResponse> {
    const qs = new URLSearchParams();
    if (params?.fromDate) qs.set('fromDate', params.fromDate);
    if (params?.toDate) qs.set('toDate', params.toDate);
    if (params?.includeDailyRows) qs.set('includeDailyRows', 'true');
    const query = qs.toString();
    return apiFetch(`/api/project/${projectUuid}/consumption/summary${query ? `?${query}` : ''}`);
  },

  sync(projectUuid: string): Promise<ConsumptionSyncResponse> {
    return apiFetch(`/api/project/${projectUuid}/consumption/sync`, { method: 'POST' });
  },
};

export const dashboardConsumptionApi = {
  getSettings(projectUuid: string): Promise<DashboardConsumptionSettingsResponse> {
    return apiFetch(`/api/project/${projectUuid}/consumption/dashboards/settings`);
  },

  getSummary(
    projectUuid: string,
    params?: { fromDate?: string; toDate?: string }
  ): Promise<DashboardConsumptionSummaryResponse> {
    const qs = new URLSearchParams();
    if (params?.fromDate) qs.set('fromDate', params.fromDate);
    if (params?.toDate) qs.set('toDate', params.toDate);
    const query = qs.toString();
    return apiFetch(
      `/api/project/${projectUuid}/consumption/dashboards/summary${query ? `?${query}` : ''}`
    );
  },

  sync(projectUuid: string): Promise<DashboardConsumptionSyncResponse> {
    return apiFetch(`/api/project/${projectUuid}/consumption/dashboards/sync`, { method: 'POST' });
  },
};
